import React, { PropsWithChildren, ReactNode } from 'react'
import { InputLabel } from '@node-space/storybook-components/dist/FormElements'
import Tooltip from '@node-space/storybook-components/dist/Tooltip'
import { Box, Icon } from '@node-space/ui-components'

export interface InputLabelTooltipProps extends PropsWithChildren {
  forId: string
  tooltipText: ReactNode
}

export const InputLabelTooltip = ({ children, forId, tooltipText }: InputLabelTooltipProps) => {
  return (
    <InputLabel forId={forId}>
      <Box tag="span" flex align="center" gapX={4}>
        {children}
        <Tooltip id={`tooltip-${forId}`} position="right" hasMaxWidth bodyContent={tooltipText}>
          <Icon name="Info" size="small" />
        </Tooltip>
      </Box>
    </InputLabel>
  )
}
